import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import { STAGE_LABELS } from './autopsyConstants';

const STAGE_COLORS = {
  classification: '#f59e0b',
  kb_gate: '#a855f7',
  agent: '#22c55e',
  coordinator_post_turn: '#6366f1',
};

export default function AutopsyCoverageChart({ turn }) {
  if (!turn?.stages) {
    return <p className="text-xs text-zinc-400 text-center py-8">Selecciona un turno con datos</p>;
  }

  const byLabel = {};
  Object.entries(turn.stages).forEach(([stageKey, stageData]) => {
    const blocks = stageData?.injection_manifest?.blocks || [];
    blocks.forEach((b) => {
      if (!b.injected || !b.chars) return;
      const label = b.label || b.source;
      if (!byLabel[label]) byLabel[label] = { label, total: 0 };
      byLabel[label][stageKey] = (byLabel[label][stageKey] || 0) + b.chars;
      byLabel[label].total += b.chars;
    });
  });

  const data = Object.values(byLabel).sort((a, b) => b.total - a.total).slice(0, 12);
  if (!data.length) {
    return <p className="text-xs text-zinc-400 text-center py-8">Sin bloques inyectados en este turno</p>;
  }

  const stageKeys = Object.keys(STAGE_LABELS);

  return (
    <div className="h-72 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ left: 8, right: 8, top: 8, bottom: 8 }}>
          <XAxis type="number" tick={{ fontSize: 10 }} />
          <YAxis type="category" dataKey="label" width={120} tick={{ fontSize: 9 }} />
          <Tooltip formatter={(v) => [`${v} chars`, '']} />
          <Legend wrapperStyle={{ fontSize: 10 }} />
          {stageKeys.map((sk) => (
            <Bar
              key={sk}
              dataKey={sk}
              name={STAGE_LABELS[sk]}
              stackId="a"
              fill={STAGE_COLORS[sk] || '#94a3b8'}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
